<template>

  <div class="panel-middle">
    <template v-if="selected.settings && selected.settings.form">
      <h3 class="panel-top-name">{{$static('plugin.title', 'Налаштування')}}</h3>
      <div class="row" v-for="(field, index) in selected.settings.form" :key="index">
        <div class="col" v-if="field.type === 'text'">
          <div class="form-group">
            <div class="custom-label">{{field.label}}</div>
            <input type="text" class="form-control custom-input" :placeholder="field.placeholder"
                   v-model="selected.settings[field.key]" @update:modelValue="e => setValue(field.key,e)">
          </div>
        </div>
        <div class="col" v-if="field.type === 'select'">
          <div class="form-group">
            <label class="custom-label">{{field.label}}</label>
            <div class="selector-holder ">
              <v-select>
                <template #open-indicator="{ attributes }">
                        <span v-bind="attributes">
                          <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                  fill="#212121"/>
                          </svg>
                        </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col" v-if="field.type ==='textarea'">
          <div class="form-group">
            <div class="custom-label">{{field.label}}</div>
            <textarea class="form-control custom-input"
                      v-model="selected.settings[field.key]" @update:modelValue="e => setValue(field.key,e)"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-3" v-if="field.type === 'checkbox'">
            <div class="form-group">
              <div class="option-box mt-0" style="border-bottom:1px solid #c8cfd9;padding-bottom: 15px">
                <div class="option-line mt-0">
                  <div class="option-name">{{field.label}}</div>
                  <div class="toggle-holder">
                    <div class="toggler r">
                      <input type="checkbox" class="toggle-check"
                             v-model="selected.settings[field.key]" @update:modelValue="e => setValue(field.key,e)">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </template>
    <template v-if="selected.manifest && selected.manifest.form">
      <h3 class="panel-top-name">{{$static('plugin.t1', 'Поля')}}</h3>
      <div class="row" v-for="(field, index) in selected.manifest.form" :key="index">
        <div class="col" v-if="field.type === 'text'">
          <div class="form-group">
            <div class="custom-label">{{field.label}}</div>
            <input type="text" v-if="basicLang" class="form-control custom-input" :placeholder="field.placeholder"
                   v-model="selected.manifest[field.key]" @update:modelValue="e => setManifestValue(field.key,e)">

            <input type="text" v-else class="form-control custom-input translate" :placeholder="field.placeholder"
                   v-model="translate[field.key]" @update:modelValue="e => setManifestValue(field.key,e)">
          </div>
        </div>

        <div class="col" v-if="field.type === 'select'">
          <div class="form-group">
            <label class="custom-label">{{field.label}}</label>
            <div class="selector-holder ">
              <v-select>
                <template #open-indicator="{ attributes }">
                      <span v-bind="attributes">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M15.1528 8.22224C15.4213 8.49072 15.4213 8.92602 15.1528 9.19451L11.4861 12.8612C11.2177 13.1297 10.7824 13.1297 10.5139 12.8612L6.84721 9.19451C6.57872 8.92602 6.57872 8.49072 6.84721 8.22224C7.11569 7.95375 7.55099 7.95375 7.81948 8.22224L11 11.4028L14.1805 8.22224C14.449 7.95375 14.8843 7.95375 15.1528 8.22224Z"
                                fill="#212121"/>
                        </svg>
                      </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="col" v-if="field.type ==='textarea'">
          <div class="form-group">
            <div class="custom-label">{{field.label}}</div>
            <textarea class="form-control custom-input"
                      v-model="selected.manifest[field.key]" @update:modelValue="e => setManifestValue(field.key,e)"></textarea>
          </div>
        </div>
        <div class="col" v-if="field.type === 'checkbox'">
          <div class="form-group">
            <div class="option-box mt-0" style="border-bottom:1px solid #c8cfd9;padding-bottom: 15px">
              <div class="option-line mt-0">
                <div class="option-name">{{field.label}}</div>
                <div class="toggle-holder">
                  <div class="toggler r">
                    <input type="checkbox" class="toggle-check"
                           v-model="selected.manifest[field.key]" @update:modelValue="e => setManifestValue(field.key,e)">
                    <div class="knobs"></div>
                    <div class="layer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="row" v-if="selected && selected.settings && selected.settings.description">
      <div class="col" v-html="selected.settings.description">

      </div>
    </div>

  </div>

</template>
<script>
  export default {
    name    : 'PluginEditor',
    props   : {
      title   : {},
      selected: {},
      lang    : {}
    },
    computed: {
      basicLang() {
        return this.lang === ''
      },
      translate: {
        get() {
          return this.lang && this.selected.manifest.translate && this.selected.manifest.translate[this.lang] ? this.selected.manifest.translate[this.lang] : {}
        },
        set(value) {
          // if (this.lang){
          //   this.item.translate[this.lang] = value
          // }
        }
      },
    },
    methods : {
      setValue(key, value) {
        this.selected.settings[key] = value
      },

      setManifestValue(key, value) {
        if(this.lang){
          if (!this.selected.manifest.translate){
            this.selected.manifest.translate = {}
          }
          if (!this.selected.manifest.translate[this.lang]){
            this.selected.manifest.translate[this.lang] = {}
          }
          this.selected.manifest.translate[this.lang][key] = value
        }else{
          this.selected.manifest[key] = value;
        }
      }
    }
  }
</script>
